import { render, staticRenderFns } from "./ReporteNacionales.vue?vue&type=template&id=5f61d98b"
import script from "./ReporteNacionales.vue?vue&type=script&lang=js"
export * from "./ReporteNacionales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports